import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  GetAllMembershipCommand,
  GetMembershipByResidentAndStatusesCommand,
  CancelMembershipCommand,
} from './membership.commands';
import {
  GotAllMembershipsEvent,
  GotMembershipByResidentEvent,
  CanceledMembershipEvent,
} from './membership.events';

@Injectable()
export class MembershipEffects {
  prefix = 'membership';
  getAllMembershipCommand: Observable<Action<string>> & CreateEffectMetadata;
  getMembershipByResidentAndStatusesCommand: Observable<Action<string>> & CreateEffectMetadata;
  cancelMembershipCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.getAllMembershipCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllMembershipCommand,
      GotAllMembershipsEvent,
      this.prefix,
    );
    this.getMembershipByResidentAndStatusesCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetMembershipByResidentAndStatusesCommand,
      GotMembershipByResidentEvent,
      this.prefix,
    );
    this.cancelMembershipCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CancelMembershipCommand,
      CanceledMembershipEvent,
      this.prefix,
    );
  }
}
